<template>
  <div class="Wdgt-Auth-Module">
    <p class="Wdgt-Auth-Module__text Wdgt-Auth-Module__text--thin">Забыли свой пароль?</p>
    <TypographyHint class="Wdgt-Auth-Module__hint">Введите свой e-mail и мы вышлем Вам письмо, позволяющее сбросить пароль.</TypographyHint>
    <form class="Wdgt-Auth-Module__form">
      <TextInput class="Wdgt-Auth-Module__form-field" v-model="email" :placeholder="'Адрес электронной почты'" :errorMessage="error" :name="'email'" @update-value="clearError"/>
      <ButtonMain class="Wdgt-Auth-Module__button" :width="'100%'" @click="toResetPass" :loading="get_isLoading">Сбросить пароль</ButtonMain>
    </form>
  </div>
</template>

<script setup>
  import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
  import { useStore } from 'vuex';
  import { backendUrl } from "@shared/constants/urls/appUrls";
  import AUTH_SECTIONS_NAME from '@shared/constants/dropdowns/authSectionsName.js';
  //-----------------------
  import TypographyHint from '@ui/Typography/TypographyHint/TypographyHint.vue';
  import TextInput from '@shared/UI/Fields/TextInput/TextInput.vue';
  import ButtonMain from '@shared/UI/Buttons/ButtonMain/ButtonMain.vue';
  //-----------------------
  const store = useStore();
  //-----------------------
  const RESET_ENDPOINT = `${ backendUrl }/api/auth/users/reset_password/`;
  //-----------------------
  const error = ref();
  const email = ref('');
  //-----------------------
  onMounted(() => {
    window.addEventListener('keydown', onEnterKeyPress);
  });
  onBeforeUnmount(() => {
    window.removeEventListener('keydown', onEnterKeyPress);
  });
  //-----------------------
  //Статус отправки данных
  const get_isLoading = computed(() => store.state.AuthorizationSystem.isLoading)
  //-----------------------
  //Запустить процесс сброса пароля
  const toResetPass = async () => {
    if (get_isLoading.value) return;
    const value = email.value.trim();
    if (!value) { error.value = 'Введите e-mail'; return; }
    toChangeLoadingFlag(true);
    try {
      const response = await fetch(RESET_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: value })
      });
      if (response.ok) {
        toOpenSignupSection();
      } else {
        const data = await response.json();
        if (response.status === 400 && data.email) {
          error.value = data.email.join(' ');
        } else {
          error.value = 'Произошла ошибка при отправке письма.';
        }
      }
    } catch (err) {
      error.value = 'Ошибка сети: ' + err.message;
    } finally {
      toChangeLoadingFlag(false);
    }
  }
  //Очистить поле ошибки
  const clearError = () => { error.value = ''; }
  //Отметить процесс отправки данных на сервер
  const toChangeLoadingFlag = (status) => store.commit('AuthorizationSystem/toChangeLoadingFlag', status);
  //Открыть секцию с успешной отправкой письма с восстановлением на почту
  const toOpenSignupSection = () => {
    store.commit('AuthorizationSystem/toActiveSection', AUTH_SECTIONS_NAME.FORGOT_PASS_SUCCESS);
  }
  //Глобальный обработчик для Enter
  const onEnterKeyPress = (e) => {
    const key = e.key || e.keyCode;
    if (key === 'Enter' || key === 13) {
      e.preventDefault();
      toResetPass();
    }
  };
</script>

<style lang="scss">
  @import '../../styles/Wdgt-Auth-Module.scss';
</style>
